module.exports = __webpack_public_path__ + "img/car-building.35ba1e50.svg";